<div class="container-color main-container">
  <div class="report-list-header rr-container-white">
    <div class="report-controls">
      <div class="d-flex flex-wrap flex-column flex-lg-row justify-content-between align-items-center pb-3">
        <!--ALL/FAVORITES BUTTONS-->
        <div class="pb-2 d-flex align-items-center">
          <div class="btn-group" role="button">
            <button class="btn fw-700" type="button" (click)="changeGroupView('all')" [class.btn-primary]="groupView == 'all'" [class.btn-outline-secondary]="groupView != 'all'">All Reports</button>
            <button class="btn fw-700" type="button" (click)="changeGroupView('favorites')" [class.btn-primary]="groupView == 'favorites'" [class.btn-outline-secondary]="groupView != 'favorites'">
              <i [class.fas]="groupView == 'favorites'" [class.far]="groupView != 'favorites'" class="fa-star"></i>
              Favorites
            </button>
          </div>
        </div>

        <!--SEARCH BAR-->
        <p-iconField iconPosition="left" class="pb-2">
          <p-inputIcon styleClass="pi pi-search" />
          <input type="text" pInputText placeholder="Filter by report name or group" trim="blur" name="reportQuery" [(ngModel)]="filters.reportQuery" (keyup)="onQueryChange($event)" style="min-width: 25vw;" />
        </p-iconField>

        <!--GALLERY/LIST BUTTONS-->
        <div class="d-flex align-items-center pb-2" style="width: 175px;">
          <div class="btn-group" role="button" *ngIf="!showReportList && availableReports.length > 1">
            <button class="btn btn-sm" [class.btn-outline-dark]="listDisplay" [class.btn-dark]="!listDisplay" (click)="swapViews(false)" title="Gallery view"><i class="fas fa-th-large pr-2"></i>Groups</button>
            <button class="btn btn-sm" [class.btn-outline-dark]="!listDisplay" [class.btn-dark]="listDisplay" (click)="swapViews(true)" title="List view"><i class="fas fa-bars pr-2"></i>List</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="rr-container-color">
    <div *ngIf="isLoading" class="py-4">
      <app-loading-indicator [large]="true" [message]="'Loading reports...'"></app-loading-indicator>
    </div>

    <div class="error-container" *ngIf="errorRetrievingReports" style="text-align: center; padding: 4em 1em">
      <h5><strong>An error has occurred with your session. Please <a routerLink="/logout">sign out</a> and login again.</strong></h5>
      <p>If this problem persists, please contact the <a href="mailto:support@mi4.com?Subject=Portal%20Issue">Mi4 Support Team.</a></p>
    </div>

    <div class="error-container" *ngIf="noReportsReceived" style="text-align: center; padding: 4em 1em">
      <div class="py-4">
        <img src="/assets/no-dashboard-img.svg" alt="No dashboards image" style="height: 125px;" />
      </div>
      <h5><strong>You are not currently authorized to view any reports.</strong></h5>
      <p>Please contact <a href="mailto:support@mi4.com">Mi4 Support</a> or your IT administrator to request access to reports.</p>
    </div>

    <!--ALL VIEW-->
    <div *ngIf="!listDisplay">
      <div *ngIf="!isLoading && !noReportsReceived && !errorRetrievingReports">
        <div *ngIf="groupView == 'all' && !showReportList">
          <div class="card-body pt-4" *ngIf="availableReports.length > 1">
            <div class="row">
              <div class="col-sm-6 col-md-4 field-card" *ngFor="let group of availableReports  | reportGroupQueryFilter: filters.reportQuery: favoriteReports.reports.length">
                <div class="card">
                  <div class="card-body pointer-cursor" (click)="openReportGroup(group.reportGroupID)">
                    <h5 class="card-title">
                      <strong><span class="category-icon"><i class="far fa-folder"></i></span> {{ group.reportGroup }}</strong>
                    </h5>
                    <div class="text-right">
                      <span *ngIf="group.reports.length == 1">1 report</span>
                      <span *ngIf="group.reports.length > 1">{{ group.reports.length }} reports</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="(availableReports | reportGroupQueryFilter: filters.reportQuery: favoriteReports.reports.length).length == 0" class="text-center">
              <p><em>No reports matching filters found</em></p>
            </div>
          </div>
        </div>

        <!--REPORT LIST OF A GROUP-->
        <div *ngIf="availableReports.length == 1 || showReportList">
          <button pButton class="p-button-raised p-button-text p-button-info btn-sm bg-white mb-4" (click)="backToGroups()" type="button" *ngIf="availableReports.length > 1"><i class="fas fa-arrow-left pr-2"></i>Back to Groups</button>
          <app-report-list-view [groupView]="groupView"
                                [reportServer]="reportServer"
                                [filters]="filters"
                                [groupID]="groupID">
          </app-report-list-view>
        </div>
        <!--FAVORITES VIEW-->
        <div *ngIf="groupView == 'favorites' && !showReportList && availableReports.length > 1">
          <div class="card-body pt-4">
            <div *ngIf="favoriteErrorMessage">
              <p style="color: #d9534f;">{{favoriteErrorMessage}}</p>
            </div>
            <div class="text-center p-4" *ngIf="!favoriteReports || !favoriteReports.reports || (favoriteReports.reports.length == 0)">
              <div class="py-4">
                <img src="/assets/no-data-img.svg" alt="No data image" style="height: 125px;" />
              </div>
              <p>You do not currently have any Favorite Reports.</p>
              <p>To favorite a report click the <span class="px-1"><i class="far fa-star"></i></span> next to the report name.</p>
            </div>
            <div *ngIf="favoriteReports" class="">
              <div class="row">
                <div class="col-sm-4 field-card" *ngFor="let favGroup of favoriteGroups  | reportGroupQueryFilter: filters.reportQuery: favoriteReports.reports.length">
                  <div class="card">
                    <div class="card-body pointer-cursor" (click)="openReportGroup(favGroup.reportGroupID)">
                      <h5 class="card-title">
                        <strong><span class="category-icon"><i class="far fa-folder"></i></span> {{ favGroup.reportGroup }}</strong>
                      </h5>
                      <div class="d-flex justify-content-between align-items-center">
                        <span class="favorited-icon"><i class="fas fa-star"></i></span>
                        <div class="text-right">
                          <span *ngIf="favGroup.reports.length == 1">1 report</span>
                          <span *ngIf="favGroup.reports.length > 1">{{ favGroup.reports.length }} reports</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="favoriteReports && favoriteReports.reports && (favoriteReports.reports.length > 0) && (favoriteGroups | reportGroupQueryFilter: filters.reportQuery: favoriteReports.reports.length).length == 0" class="text-center">
              <p><em>No reports matching filters found</em></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--LIST VIEW-->
    <div *ngIf="listDisplay && !isLoading">
      <app-report-list-view [groupView]="groupView"
                            [reportServer]="reportServer"
                            [filters]="filters"
                            [groupID]="groupID">
      </app-report-list-view>
    </div>
  </div>

  <!--<scroll-to-top-btn></scroll-to-top-btn>-->
</div>
